<template>
  <div>
    <div style="min-height:300px">
      <fieldset>
        <div class="row">
          <legend class="no-padding-bottom">FRAME INFORMATION</legend>
          <small class="note" v-if="showLabel && isProgressive">If you selected a Varilux lens, it should be fitted center pupil.</small>
        </div>
      </fieldset>
      <ftc-to-lab-supply-frame-toggler v-model="mode" v-if="showFTCToLabSupplyFrameToggler"></ftc-to-lab-supply-frame-toggler>
      <br>
      <frame-to-come-info v-if="showFTC" :sampleobject="sampleobject" :program="program"></frame-to-come-info>
      <lab-supply-frame-info v-if="showLSF" :sampleobject="sampleobject" :program="program"></lab-supply-frame-info>
    </div>
  </div>

</template>
<script>
import FtcToLabSupplyFrameToggler from "@/components/order/frame/FtcToLabSupplyFrameToggler";
import FrameToComeInfo from "@/components/order/frame/FrameToComeInfo";
import LabSupplyFrameInfo from "@/components/order/frame/LabSupplyFrameInfo";
export default {
  props: ["sampleobject", "program"],
  inject: ["$validator"],
  components: {
    FtcToLabSupplyFrameToggler,
    FrameToComeInfo,
    LabSupplyFrameInfo
  },
  data() {
    return {
      mode: ""
    };
  },
  computed: {
    showFTCToLabSupplyFrameToggler() {
      return (
        this.program &&
        this.program.jobType === "PICK" &&
        this.sampleobject.uncut === false
      );
    },
    showFTCToLabSupplyFrameToggler2() {
      return (
        this.program &&
        this.program.jobType === "REP" &&
        this.sampleobject.uncut === false
      );
    },
    showFTC() {
      return (
        (this.program &&
          this.program.jobType === "PICK" &&
          this.mode === "frame-to-come") ||
        this.program.jobType === "FTC"
      );
    },
    showLSF() {
      return (
        this.sampleobject.uncut === false &&
        ((this.program &&
          (this.program.jobType === "PICK" || this.program.jobType === "REP" || this.program.jobType === "LUX") &&
          this.mode === "lab-supplied-frame") ||
          this.program.jobType === "TPB")
      );
    },
    showLabel() {
      return !(this.sampleobject.programId == 'TRCPP' || this.sampleobject.programId == 'TRCPS');
    },
    isProgressive() {
      return this.program.isProgressive;
    }
  },
  created() {
    if (this.sampleobject.isLabSuppliedFrame) {
      this.mode = "lab-supplied-frame";
    } else {
      this.mode = "frame-to-come";
    }
  },
  watch: {
    mode(newValue) {
      if (newValue === "lab-supplied-frame") {
        this.sampleobject.isLabSuppliedFrame = true;
      } else {
        this.sampleobject.isLabSuppliedFrame = false;
      }
    }
  }
};
</script>
<style>
.frame-review-section {
  margin-top: 15px;
}
.uncut-smalltext {
  font-size: 11pt;
}
.note {
  color: red;
  font-weight: bold;
}
.no-padding-bottom {
  padding-bottom: 0;
  margin-bottom: 0;
}
</style>